
import { BaseService } from './baseservice';

class ReportsServiceClass extends BaseService {

    async removeKpiIndicator(data, isIndividual) {
        let url = '/remove_indicator';
        if (isIndividual && ENVIRONMENT.IS_OPERATIONS_KPIS) url += '/individual';
        const response = await this.fetch(
            'PUT',
            url,
            data
        );

        if (response && response.data) {
            return response.data;
        }
    }

    async load(url) {
        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data;
        }
    }

    async paste(payload, report, org) {
        const response = await this.fetch('PUT', '/org/' + org + '/paste/' + report, { data: payload });

        if (response && response.data) {
            return response.data;
        }
    }

    async saveKpi(body) {
        body.position = 0;
        const response = await this.fetch('POST', '/kpis', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateKpi(body) {
        const response = await this.fetch('PUT', '/kpis/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateKpiPosition(body) {
        const response = await this.fetch('PUT', '/kpis/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteKpi(id) {
        const response = await this.fetch('DELETE', '/kpis/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    async saveEmployee(body) {
        body.locked = 0;
        const response = await this.fetch('POST', '/employees', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateEmployee(body) {

        const response = await this.fetch('PUT', '/employees/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateTeam(body) {

        const response = await this.fetch('PUT', '/teams/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveTeam(body) {
        body.position = 0;
        const response = await this.fetch('POST', '/teams', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateTeamPosition(body) {
        const response = await this.fetch('PUT', '/teams/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateEmployeePosition(body) {
        const response = await this.fetch('PUT', '/employees/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveSection(body) {
        body.position = 0;
        const response = await this.fetch('POST', '/sections', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateSection(body) {
        const response = await this.fetch('PUT', '/sections/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateSectionPosition(body) {
        const response = await this.fetch('PUT', '/sections/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteSection(id) {
        const response = await this.fetch('DELETE', '/sections/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteEmployee(id) {
        const response = await this.fetch('DELETE', '/employees/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteTeam(id) {
        const response = await this.fetch('DELETE', '/teams/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveKpiData(body) {
        const response = await this.fetch('POST', '/kpi_data', body);
        if (response && response.data) {
           return response.data;
        }
    }

    async saveEmployeeStat(body) {
        const response = await this.fetch('POST', '/employee_stats', body);
        if (response && response.data) {
            return response.data;
        }
    }

    //---------------------//
    //         HR         //
    //--------------------//

    // Censuses
    async saveCensus(body) {
        const response = await this.fetch('POST', '/termination_censuses', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateCensusData(body) {
        const response = await this.fetch('PUT', '/termination_censuses/' + body.id, body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    async deleteCensus(id) {
        const response = await this.fetch('DELETE', '/termination_censuses/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Hr pasting
    async hrPasting(body, org) {
        const response = await this.fetch('PUT', '/org/' + org + '/hr_pasting', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    // Candidate
    async updateCandidateData(body, model) {
        const response = await this.fetch('PUT', '/'+ model + '/' + body.id, body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    async saveCandidate(body) {
        const response = await this.fetch('POST', '/candidates', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateCandidate(body) {
        const response = await this.fetch('PUT', '/candidates/'+body.id, body);
        if (response && response.data) {
            return response.data;
        }
    }

    async deleteCandidate(id) {
        const response = await this.fetch('DELETE', '/candidates/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Candidate Trackings
    async updateCandidateTRacking(body) {
        const response = await this.fetch('PUT', '/candidate_trackings/'+body.id, body);
        if (response && response.data) {
            return response.data;
        }
    }

    // Staffing Budget
    async saveStaffingBudget(body) {
        const response = await this.fetch('POST', '/staffing_budget', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async deleteStaff(id) {
        const response = await this.fetch('DELETE', '/staff/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Options
    async saveOption(body) {
        const response = await this.fetch('POST', '/dashboard_options', body);
        if (response && response.data) {
            return response.data;
        }
    }

    // Staff
    async saveStaff(body) {
        const response = await this.fetch('POST', '/staff', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async getUsersPermissions(org_id){
        const response = await this.fetch('GET', '/permissions/organization/' + org_id);
        if (response && response.data) {
            return response.data;
        }
    }

    async updatePermission(org_id, user_id, section, value){
        const response = await this.fetch('PUT', '/permissions/organization/'
            + org_id + '/user/' + user_id + '/section/' + section + '/set/' + value);

        if (response && response.data) {
            return response.data;
        }
    }

    // Staffing budget staff data
    async saveStaffingBudgetStaffData(body) {
        const response = await this.fetch('POST', '/staffing_budget_staff', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    // Staffing aggregate data
    async updateMonthlyTracker(body) {
        const response = await this.fetch('POST', '/monthly_tracker', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    // Operations KPIS
    async saveRoleBudget(body) {
        const response = await this.fetch('POST', '/roles_budget', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }
}

let ReportsService = new ReportsServiceClass(ENVIRONMENT.API_HOST);
export default ReportsService;
